import { Component, OnInit, Directive, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { config } from '../../app.config';
import { LoginService } from './login.service';
import { AppComponent } from './../../app.component';
import { SocketService } from './../../socket/socket.service';
import { AlertPopup, HttpLoader } from './../../app.config';
import { ValidationService } from '../form-validation/validation.service';
import { DataSharingService } from 'app/shared/data-sharing.service';
import { AssistBotService } from '../ai-assist/assist-bot.service';
import { LlmService } from 'app/services/llm.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { HeaderService } from '../header/header.service';
import { UserService } from '../userandgroup/user/user.service';
import { IndexedDBService } from 'app/services/indexed-db.service';

// @Directive()
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: []
})

export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  showBtnSpinner = false;
  showSpinner = false;
  loginErrMsg: string = "";
  copyRights: number = config.copyrights;
  show: boolean;
  isloginBtnShow = false;
  hostlogo: any;
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private socketService: SocketService,
    @Inject(DOCUMENT) private document: Document,
    private loader: HttpLoader,
    private alert: AlertPopup, private userService: UserService, private indexedDBService: IndexedDBService,
    private dataSharingService: DataSharingService, private headerService: HeaderService,
    private app: AppComponent, private assistBotService: AssistBotService, private llmService: LlmService) {
    this.loginForm = formBuilder.group({
      email_id: ['', Validators.compose([Validators.required, ValidationService.emailValidator])],
      password: [null]
    });

    // this.loginForm = formBuilder.group({
    //   email_id: ['baskar@test.com', Validators.required],
    //   password: ['password123', Validators.required]
    // });

  }

  ngOnInit() {
   
    // this.assistBotService.getClientConfig().subscribe((res:any)=>{
    //           this.assistBotService.GptConfiguration = res.filter((configlist:any)=> configlist['clientModule']==client)[0]['configuration'];
    //  });
  }

  showHidePassword() {
    this.show = !this.show;
  }


  clearLocalStorage() {
    window.localStorage.clear();
  };

  /**
   * User Authentication Email Verified Function
   * @param formValue
   */

  authenticateEmailVerify(formValue) {
    try {
      this.showSpinner = true;
      this.loader.showLoader();
      this.loginService.authenticateEmail(formValue).subscribe((response: any) => {
        this.loader.hideLoader();

        if (response.data['acc_active'] === true) {
          this.showSpinner = false;
          this.isloginBtnShow = true;
          this.loginForm.get('password').setValidators([Validators.required, ValidationService.passwordValidate]);
          this.loginForm.controls['password'].enable();
        }
        if (response.data['acc_active'] == false) {
          this.showSpinner = false;
          this.loader.hideLoader();
          this.loginErrMsg = `Your account has been deactivated`
          // this.alert.showAlertMessage({'message':'Your account has been deactivated'});

          setTimeout(() => {
            this.loginErrMsg = '';
          }, 3000);
        }
      }, error => {
        // this.alert.showAlertMessage(error.error);
        this.loginErrMsg = error.error['message'];
        // console.log(error), 'error';
        setTimeout(() => {
          this.loginErrMsg = '';
        }, 3000);



        this.showSpinner = false;
        this.loader.hideLoader();
      })
    } catch (error) {
      this.loader.hideLoader();
      this.showSpinner = false;
      console.log(error);
    }
  }

  /**
   * User Authentication Function
   * @param formValue
   */
  authenticateUser(formValue) {
    try {
      this.showBtnSpinner = true;
      this.isloginBtnShow = true;
      this.loader.showLoader();
      this.loginService.authenticateUser(formValue).subscribe(
        (user) => {
          this.loader.hideLoader();
          if (user['success']) {
            window.localStorage.user_id = JSON.stringify(user['user_id']);
            window.localStorage.user_role = JSON.stringify(user['user_role']);
            window.localStorage.token = JSON.stringify(user['token']);
            window.localStorage.company_id = JSON.stringify(user['company_id']);
            this.indexedDBService.addData({
              email: formValue['email_id'], 'section': [
                { 'name': 'aiassist', 'complete': false },
                { 'name': 'elibrary', 'complete': false },
                { 'name': 'manageuser', 'complete': false },
                { 'name': 'discussion', 'complete': false },
                { 'name': 'notification', 'complete': false },
                { 'name': 'settings', 'complete': false },
                { 'name': 'videoquiz', 'complete': false },
                { 'name': 'summarization', 'complete': false }
              ]
            });
            this.llmService.llmUserList().subscribe((userListRes: any) => {

              if (userListRes['users'].length > 0) {
                this.llmService.LLM_user_list = userListRes['users'];
                let index = userListRes['users'].filter((userlist: any) => userlist['user_id'] == user['user_id']).length;
                if (index) {

                }
              }
            });

            this.llmService.llmUserLogin({ "client_id": user['company_id'], "user_id": user['user_id'] }).subscribe((llmresponse: any) => {
              if (llmresponse.hasOwnProperty("token")) {
                window.localStorage.setItem("llm_token", llmresponse["token"]);
                this.app.getCurrentUserData();
                this.app.getUserStatusData();
              }
            }, (error: HttpErrorResponse) => {
              if (localStorage.getItem("token")) {
                this.userService.getCurrentUserDetail().subscribe((userResponse: any) => {
                  // console.log("userResponse",userResponse);
                  let userDetail = userResponse['userDetail'];
                  let payLoad = {
                    "client_id": userDetail['company_id'],
                    "user_id": userDetail['user_id'],
                    "email": formValue['email_id'],
                    "full_name": userDetail['first_name'] + " " + userDetail['last_name']
                  };

                  this.llmService.llmCreateUser(payLoad).subscribe((llmres: any) => {
                    this.app.getCurrentUserData();
                    this.app.getUserStatusData();
                  }, (error: HttpErrorResponse) => {
                    this.app.getCurrentUserData();
                    this.app.getUserStatusData();
                  });

                }, (error: HttpErrorResponse) => {
                  this.app.getCurrentUserData();
                  this.app.getUserStatusData();
                });
              }


            });




            // this.socketService.initiateSocket().then(connected => {
            //   this.app.observableRefresh();
            // }).catch(err => {
            //   console.log(err);
            // });
            this.showBtnSpinner = false;
            // if(user['user_role']==1 || user['user_role']==2){

            //  /// this.router.navigate(['/elibraryandcourse/e-library']);
            // }else{
            //   this.router.navigate(['main/aiassist']);
            //  // this.router.navigate(['/elibraryandcourse/e-library']);
            // }
          }

        },
        (error) => {
          const errMsg = JSON.stringify(error.error['message']).replace(/['"]+/g, '');
          this.loginErrMsg = error.error['message'];

          // this.alert.showAlertMessage(error.error);
          this.showBtnSpinner = false;
          this.loader.hideLoader();
          setTimeout(() => {
            this.loginErrMsg = "";
          }, 3000);
        }
      )
    } catch (err) {
      this.loader.hideLoader();
    }
    // this.hintService.initialize({elementsDisabled: false});
  };

  removeErrMsg() {
    this.loginErrMsg = "";
  }

  ngAfterViewInit() {
    this.llmService.llmRunningStarus().subscribe({
      next: (res: any) => {

      }, error: (error: HttpErrorResponse) => {

        this.alert.showAlertMessage({ "message": "AI Model not running currently" });
        // (<HTMLElement> this.document.getElementsByClassName("login-btn")[0]).style.display='none';

      }
    });
  }

  redirectToforgetpass() {
    let forgotMail = this.loginForm.get('email_id').value;

    this.dataSharingService.emitgetForgotMailId(forgotMail);
    window.sessionStorage.setItem('email_id', forgotMail);

    this.router.navigate(['/forgot_password']);
  };

  redirectTosignup() {
    this.router.navigate(['/sign_up']);
  };

}



